export default __webpack_public_path__ + "static/media/logo-pix-white.0c2dfd17.png";